const MyBuyers = () => {
  return <></>;
};

export default MyBuyers;
